var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-new",style:({width: _vm.progressWidth})},[_c('div',{staticClass:"progress-new__indicator"},_vm._l((_vm.progressSteps),function(step){return _c('div',{staticClass:"progress-new__indicator-step",class:{'progress-new__indicator-step--active': _vm.isProgressAboveStep(step)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }